import Vue from 'vue';
import LDService from '@/services/launchdarkly';

const LaunchDarklyPlugin = {
  install(Vue) {
    Vue.prototype.$ld = LDService;
  },
};

Vue.use(LaunchDarklyPlugin);